// Actions
import {
  SET_QR_CODES_DATA,
  SET_QR_CODES_LOADER,
  CREATE_QR_CODE,
  UPDATE_QR_CODE,
  DELETE_QR_CODE,
  UPDATE_QR_CODE_STATUS,
  SET_QR_CODE_SCANNED_CONTACTS_DATA,
  SET_QR_CODE_SCANNED_CONTACTS_LOADER,
  LOGOUT,
} from '../actions/action-types';

const initialState = {
  qrCodes: [],
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 20,
  loading: false,
  totalRecordsInDB: null,
  
  // Scanned contacts
  scannedContacts: [],
  scannedContactsRowsCount: 0,
  scannedContactsTo: null,
  scannedContactsFrom: null,
  scannedContactsLastPage: null,
  scannedContactsCurrentPage: null,
  scannedContactsPerPage: 20,
  scannedContactsLoader: false,
};

const qrCodesReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_QR_CODES_DATA:
      return {
        ...state,
        qrCodes: payload.rows,
        rowsCount: payload.count,
        to: payload.to,
        from: payload.from,
        lastPage: payload.lastPage,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
        totalRecordsInDB: payload.totalRecordsInDB
      };
      
    case SET_QR_CODES_LOADER:
      return { ...state, loading: payload };
      
    case CREATE_QR_CODE:
      return {
        ...state,
        qrCodes: [payload, ...state.qrCodes],
        rowsCount: state.rowsCount + 1,
      };
      
    case UPDATE_QR_CODE:
      return {
        ...state,
        qrCodes: state.qrCodes.map((qrCode) =>
          qrCode.id === payload.id ? { ...qrCode, ...payload } : qrCode
        ),
      };
      
    case DELETE_QR_CODE:
      return {
        ...state,
        qrCodes: state.qrCodes.filter((qrCode) => qrCode.id !== payload.id),
        rowsCount: state.rowsCount > 0 ? state.rowsCount - 1 : 0,
      };
      
    case UPDATE_QR_CODE_STATUS:
      return {
        ...state,
        qrCodes: state.qrCodes.map((qrCode) =>
          qrCode.id === payload.id ? { ...qrCode, ...payload } : qrCode
        ),
      };
      
    case SET_QR_CODE_SCANNED_CONTACTS_DATA:
      return {
        ...state,
        scannedContacts: payload.rows,
        scannedContactsRowsCount: payload.count,
        scannedContactsTo: payload.to,
        scannedContactsFrom: payload.from,
        scannedContactsLastPage: payload.lastPage,
        scannedContactsCurrentPage: payload.currentPage,
        scannedContactsPerPage: payload.perPage,
        scannedContactsTotalRecordsInDB: payload.totalRecordsInDB
      };
      
    case SET_QR_CODE_SCANNED_CONTACTS_LOADER:
      return { ...state, scannedContactsLoader: payload };
      
    case LOGOUT:
      return initialState;
      
    default:
      return state;
  }
};

export { qrCodesReducers };
